import { useState } from 'react';
import { ScenarioCard } from '../../components/ScenarioCard';
import { ScenarioList } from '../../components/ScenarioList';
import { DraggableItem, DraggedItemState, ItemType } from '../../types/Scenario';
import './ScenarioPage.scss';

export const ScenarioPage: React.FC = () => {
  // Store the state of dragged items
  const [draggedItem, setDraggedItem] = useState<DraggedItemState | null>(null);
  
  // Handle drag start event
  const handleDragStart = (e: React.DragEvent, item: DraggableItem, type: ItemType): void => {
    setDraggedItem({ item, type });
  };
  
  // Handle drag end event
  const handleDragEnd = (): void => {
    setDraggedItem(null);
  };
  
  return (
    <div className="scenarioPage">
      <ScenarioCard onDragStart={handleDragStart} onDragEnd={handleDragEnd} />
      <ScenarioList draggedItem={draggedItem} />
    </div>
  );
};
